export const PROXY_URL = 'https://api.constellation-canvas.com';
export const API_PROXY_URL = `${PROXY_URL}/api`;
